import { Type } from '@angular/core';

export class CustomContainerItem {
  constructor(public id:string,public component: Type<any>, public data?: any) {
  }
}